/* eslint-disable array-callback-return */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useState } from "react";

import background from "../images/background.jpg";
import {
  Container,
  Mask,
  Perspective,
  StyledHero,
  SytledArrows,
} from "./Styled";
import Menu from "./Menu";
import MintButtons from "./MintButtons";
import { emptyPunk } from "config/basePunks";
import { AiOutlineArrowLeft, AiOutlineArrowRight } from "react-icons/ai";
import PunkCard from "./PunkCard";
import SocialNetworks from "./SocialNetworks";
import axios from "axios";
import { useReadOnlyPunkContract } from "hooks/useContract";
import { toast } from "react-toastify";
import dayjs from "dayjs";

const WHEN = 1637431200000 + 1000 * 60 * 15; // 19/11/2021 18:00 UTC
const ONE_SECOND = 1000;
const ONE_MINUTE = 60 * ONE_SECOND;
const ONE_HOUR = 60 * ONE_MINUTE;
const ONE_DAY = 24 * ONE_HOUR;

const HomeHero = () => {
  const [punks, setPunks] = useState([]);
  const [mintInProgress, setMintInProgress] = useState(false);

  const [selectedPunk, setSelectedPunk] = useState(emptyPunk);

  const [supply, setSupply] = useState(10000);

  const contract = useReadOnlyPunkContract();

  /* 
  useEffect(() => {
    setInterval(() => {
      contract
        .totalSupply()
        .then((resolve) => {
          setSupply(resolve.toNumber());
        })
        .catch((err) => console.error("err", err));
    }, 15000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  */

  const now = new Date();

  const whenDate = dayjs(WHEN);
  const [days, setDays] = useState(0);
  const [hours, setHours] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);
  const [intervalId, setIntervalId] = useState(null);
  const [canMint, setCanMint] = useState(false);

  /*
  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date();
      const rest = WHEN - now.getTime();
      if (rest < 0) {
        clearInterval(interval);
        setCanMint(true);
      }
      const days = Math.floor(rest / ONE_DAY);
      const hours = Math.floor((rest - days * ONE_DAY) / ONE_HOUR);
      const minutes = Math.floor(
        (rest - (days * ONE_DAY + hours * ONE_HOUR)) / ONE_MINUTE
      );
      const seconds = Math.floor(
        (rest - (days * ONE_DAY + hours * ONE_HOUR + minutes * ONE_MINUTE)) /
          ONE_SECOND
      );

      setDays(days);
      setHours(hours);
      setMinutes(minutes);
      setSeconds(seconds);
    }, 1000);
  }, []);
  */

  return (
    <StyledHero className="hero flex flex-col justify-center">
      <Menu />
      <Container className="content">
        <div className="flex justify-center p-5 md:p-20 flex-wrap">
          <div className="flex-col flex justify-center pr-8 max-w-md text-center mb-6 sm:mb-12">
            <h1 className="text-xl md text-2xl lg:text-4xl align-middle block">
              Join the{" "}
              <a
                rel="noreferrer"
                href={`https://twitter.com/boba_punks`}
                target="_blank"
              >
                <strong>#bobapunksquad</strong>
                {/** 
                {!canMint && (
                  <div>
                    <p>{whenDate.format("DD/MM HH:mm")}</p>
                    <p className="mt-4">
                      Time to wait: {days}days {hours}
                      hours {minutes} minutes {seconds}
                      seconds
                    </p>
                  </div>
                )}
                */}
              </a>
            </h1>
            {/** 
            <MintButtons
              canMint={canMint}
              mintSuccess={(resolve) => {
                if (!resolve) {
                  toast.error("An error has occured");
                  return;
                }

                const { events } = resolve;
                let i = 0;
                const PUNKS = [];
                const PUNKS_IDS = [];
                events.map(async ({ event, args }) => {
                  if (event === "Transfer") {
                    const tokenId = args.tokenId;
                    if (tokenId) {
                      PUNKS_IDS.push(tokenId.toString());
                    }
                  }
                });
                axios
                  .post(`${process.env.REACT_APP_BACKEND_URL}/punks`, {
                    ids: PUNKS_IDS,
                  })
                  .then((body) => body.data)
                  .then((punks: any) => {
                    punks.map(({ rank, image, traits, rarity_score, name }) => {
                      setMintInProgress(false);
                      const finalPunk = {
                        name,
                        rariry: rank,
                        image: image,
                        index: i,
                        traits: traits,
                      };
                      PUNKS.push(finalPunk);
                      setPunks(PUNKS);
                      if (PUNKS.length === 1) setSelectedPunk(finalPunk);
                      i++;
                    });
                  });
              }}
              updatePunkCard={(selected, allPunks) => {
                setSelectedPunk(selected);
                setPunks(allPunks);
              }}
              inProgress={mintInProgress}
              setInProgress={(value) => {
                setMintInProgress(value);
              }}
            />
            */}
          </div>

          <Perspective className="punk">
            {punks.length > 0 && (
              <h1 className="text-2xl lg:text-4xl">Mint results</h1>
            )}

            <PunkCard punk={selectedPunk} />
            <p className="text-center">Total minted : {supply} / 10000</p>
            {punks.length > 1 && (
              <SytledArrows>
                {selectedPunk.index > 0 && (
                  <AiOutlineArrowLeft
                    className="arrow left cursor-pointer"
                    onClick={() => {
                      setSelectedPunk(punks[selectedPunk.index - 1]);
                    }}
                  />
                )}
                {selectedPunk.index < punks.length - 1 && (
                  <AiOutlineArrowRight
                    className="arrow right cursor-pointer"
                    onClick={() => {
                      setSelectedPunk(punks[selectedPunk.index + 1]);
                    }}
                  />
                )}
              </SytledArrows>
            )}
          </Perspective>
        </div>
      </Container>
      <div className="absolute left-0 bottom-0 w-full h-full z-10 flex">
        <img
          src={background}
          className="w-full block object-cover"
          alt="punk"
        />
      </div>
      <Mask />
      <SocialNetworks />
    </StyledHero>
  );
};
export default HomeHero;
